import { EvesIconButton } from "@/common/components/atoms/iconButton/iconButton";
import { EvesTextbox } from "@/common/components/atoms/textbox/textbox";
import FilterSelector from "@/common/components/filterSelector";
import LookupComponent from "@/common/components/lookupComponent";
import Connector from "@/common/components/molecules/connectorTypes/connector";
import { ITableActionMenuModel } from "@/common/components/organisms/table/actionMenu";
import DataTable from "@/common/components/organisms/table/dataTable";
import { Content } from "@/common/components/templates/content/content";
import { DefaultPageSize } from "@/common/constants/constants";
import { autoRefresh } from "@/common/utils/autoRefreshConfig";
import {
  Action,
  ComponentKeys,
  Entity,
  Filters,
  LookupEntityType,
  TransactionStatisticsType,
} from "@/common/enums/enums";
import { getComponentValueSafe } from "@/common/utils/componentListHelper";
import {
  canListCars,
  canListChargingStations,
  canListTags,
  canListUsers,
  canUpdateCar,
  isActive,
  canAccess,
} from "@/common/utils/utils";
import { TransactionsInProgressModal } from "@/services/models/session";
import {
  exportSessions,
  getInProgressDashboard,
  getTransactionsInProgress,
} from "@/services/session";
import { Close, OpenInNew, Stop } from "@mui/icons-material";
import { Grid, InputAdornment, Tooltip } from "@mui/material";
import { CSSProperties, useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import InActivityCell from "../../shared/components/inActiveCell";
import SessionIdentifierCell from "../../shared/components/sessionIdentifierCell";
import {
  appendSessionIdentifierFilter,
  getSessionIdentifierColumn,
  mapSessionIdentifierFilterSelection,
} from "../../shared/sessionIdentifier";
import { ITransactionsInProgressStateModal } from "../../shared/models/inProgress";
import { sessionStatsMapping } from "../../shared/sessions";
import { CellStatus } from "@/common/components/organisms/table/dataTableCells";
import { OWNER_FILTER_ITEMS as Owner } from "@/common/constants/constants";
import TransactionDetails from "@/common/components/templates/transactionDetails";
import { SearchBox } from "@/common/components/searchBox";
import { useLocation } from "react-router-dom";
import { columnsType } from "@/common/models/model";
import {
  getChargingStationById,
  stopSessionTransaction,
} from "@/services/chargingStations";
import { IContextPropsModel, withContext } from "@/common/utils/withContext";
import { disableLoaderForOnce } from "@/common/utils/loadingService";
import OwnerFilter from "@/common/components/ownerFilter";
import { useTranslation } from "react-i18next";
import CommonCard from "../../shared/components/common-card";
import session from "../../../../assets/img/sessions/active-sessions.svg";
import consumption from "../../../../assets/img/sessions/consumption.svg";
import ButtonGroup from "@/common/components/molecules/buttonGroup/buttonGroup";
import saveAs from "file-saver";
import { getClientTimezone } from "@/common/utils/getClientTimezone";
import { setLoader } from "@/store/app/reducer";
import store from "@/store";

const TransactionsInProgress = (props: IContextPropsModel) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const visualID = searchParams.get("VisualID");
  const transactionIDParam = searchParams.get("TransactionID");
  const { t: translate } = useTranslation();
  const startDate = new Date(new Date().getFullYear(), 0, 1);
  startDate.setSeconds(0);
  const endDate = new Date();
  endDate.setSeconds(0);
  endDate.setHours(23);
  endDate.setMinutes(59);

  const [state, setStateData] = useState({
    connectorIDField: -1,
    defaultIssuer: true,
    isResetBtnDisabled: true,
    isTransactionDetailModalOpen: false,
    issuer: true,
    limit: DefaultPageSize,
    page: 0,
    projectFields: [],
    inactivityStatus: [],
    identifierFilter: [],
    rows: [],
    stats: [],
    search: "",
    selectedChargingStationID: "",
    selectedConnectorID: -1,
    selectedTransactionId: -1,
    siteID: "",
    siteAreaID: "",
    canExport: false,
    sortFields: "-timestamp",
    totalRowsCount: 0,
    userID: "",
    visualTagID: visualID ? visualID : "",
    isChargingStationLookupModalOpen: false,
    chargingStationName: "",
    chargingStationId: "",
    action: "",
    userName: "",
    showRFIDFilterModal: false,
    showUserLookUpModal: false,
    RFIDFilterValue: "",
    connectorID: null,
    canListSites: false,
    canListSiteAreas: false,
    siteName: "",
    siteAreaName: "",
    issuerName: Owner.CurrentOrganization,
    isSiteLookupModalOpen: false,
    isSiteAreaLookupModalOpen: false,
    selectedRecords: [],
    subStationID: "",
    subStationName: "",
    feederID: "",
    feederName: "",
    transformerID: "",
    transformerName: "",
    isSubStationIdLookupModalOpen: false,
    isFeederIdLookupModalOpen: false,
    isTransformerIdLookupModalOpen: false,
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
    canRemoteStopTransaction: false,
    transactionID: transactionIDParam ? transactionIDParam : "",
  } as ITransactionsInProgressStateModal);

  const [showfilter, setShowfilter] = useState<boolean>(false);
  const [stateOfCharge, setStateOfCharge] = useState<number>(0);

  const canViewSessionProgressSummary = canAccess(
    Entity.DASHBOARD_SUMMARY,
    Action.SESSION_IN_PROGRESS_SUMMARY
  );

  const canRemoteStopTransactionAccess = canAccess(
    Entity.TRANSACTION,
    Action.REMOTE_STOP_TRANSACTION
  );

  const canNavigateToChargingPlans = isActive(getComponentValueSafe(ComponentKeys.CHARGING_PLAN));
  const canNavigateToLogs = isActive(getComponentValueSafe(ComponentKeys.APPLICATION_LOGS));

  const isUserCanListUsers = canListUsers();
  const isUserCanListCars = canListCars();
  const isUserCanUpdateCar = canUpdateCar();
  const isUserCanListChargingStations = canListChargingStations();
  const isUserCanListTags = canListTags();
  const isOrganizationComponentActive = isActive(getComponentValueSafe(ComponentKeys.ORGANIZATION));
  const isPricingComponentActive = isActive(getComponentValueSafe(ComponentKeys.PRICING));
  const isCarComponentActive = isActive(getComponentValueSafe(ComponentKeys.CAR));
  const searchBoxRef = useRef<any>();
  const defaultSortColumn = "-timestamp";
  const chargingStationLookupRef: any = useRef(null);
  let isOnClickSiteFilterClear = false;
  const UserLookupRef: any = useRef(null);
  const RFIDLookupRef: any = useRef(null);
  const siteLookupRef: any = useRef(null);
  const siteAreaLookupRef: any = useRef(null);
  const consumptionChartRef = useRef<any>();
  const dataTableRef = useRef<any>();
  let isOnClickSiteAreaFilterClear = false;

  const { refetch: fetchTransactionsInProgress } = useQuery(
    "TransactionInprogress",
    () => {
      return getTransactionsInProgress(getTransactionInprogressParams());
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: false,
      onSuccess: (data: any) => {
        if (data) {
          const canListSites = data.canListSites;
          const canListSiteAreas = data.canListSiteAreas;
          const canExport = data.canExport;
          const transactionsData = data.result.map(
            (d: any) => new TransactionsInProgressModal(d)
          );
          setStateData((currentData) => {
            return {
              ...currentData,
              rows: transactionsData,
              totalRowsCount: data.count,
              canListSites,
              canListSiteAreas,
              canExport,
              projectFields: data.projectFields && [...data.projectFields],
            };
          });
          consumptionChartRef?.current?.refreshChart();
        }
      },
    }
  );

  const { refetch: fetchInProgressDashboard } = useQuery(
    "InprogressDashboard",
    () => {
      return getInProgressDashboard(getTransactionInprogressParams());
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: false,
      onSuccess: (data: any) => {
        if (data) {
          setStateData((currentData) => {
            return {
              ...currentData,
              stats: {
                ...currentData.stats,
                ...data.data,
              },
            };
          });
          consumptionChartRef?.current?.refreshChart();
        }
      },
    }
  );

  const getTransactionInprogressParams = (): any => {
    const TransactionInprogressGetParams: any = {
      Limit: state.limit,
      Page: state.page + 1,
      SortFields: state.sortFields,
    };

    if (isOrganizationComponentActive) {
      TransactionInprogressGetParams.WithSite = true;
      TransactionInprogressGetParams.WithCompany = true;
      TransactionInprogressGetParams.WithSiteArea = true;
      TransactionInprogressGetParams.WithTag = true;
      TransactionInprogressGetParams.WithUser = true;
      TransactionInprogressGetParams.WithCar = true;
      TransactionInprogressGetParams.WithChargingStation = true;
      TransactionInprogressGetParams.Statistics =
        TransactionStatisticsType.ONGOING;
    }
    if (stateOfCharge) {
      TransactionInprogressGetParams["StateOfCharge"] = stateOfCharge;
    }
    if (state.search !== "") {
      TransactionInprogressGetParams["Search"] = state.search;
    }
    if (state.visualTagID !== "") {
      TransactionInprogressGetParams["VisualTagID"] = state.visualTagID;
    }
    if (state.siteID !== "") {
      TransactionInprogressGetParams["SiteID"] = state.siteID;
    }
    if (state.siteAreaID !== "") {
      TransactionInprogressGetParams["SiteAreaID"] = state.siteAreaID;
    }
    if (state.userID !== "") {
      TransactionInprogressGetParams["UserID"] = state.userID;
    }
    if (state.connectorID !== null) {
      TransactionInprogressGetParams["ConnectorID"] = state.connectorID;
    }
    if (state.defaultIssuer) {
      TransactionInprogressGetParams["Issuer"] = true;
    } else {
      if (state.issuerName === Owner.CurrentOrgAPI) {
        TransactionInprogressGetParams["Issuer"] = true;
      }
      if (state.issuerName === Owner.ExternalOrgAPI) {
        TransactionInprogressGetParams["Issuer"] = false;
      }
    }
    if (state.chargingStationId) {
      TransactionInprogressGetParams["ChargingStationID"] =
        state.chargingStationId;
    }
    if (state.subStationID !== "") {
      TransactionInprogressGetParams["SubStationID"] = state.subStationID;
    }
    if (state.feederID !== "") {
      TransactionInprogressGetParams["FeederID"] = state.feederID;
    }
    if (state.transformerID !== "") {
      TransactionInprogressGetParams["TransformerID"] = state.transformerID;
    }

    if (state.transactionID !== "") {
      TransactionInprogressGetParams["Search"] = state.transactionID;
    }

    if (state.inactivityStatus.length > 0) {
      let inactivityStatus = state.inactivityStatus[0];
      for (let i = 1; i < state.inactivityStatus.length; i++)
        inactivityStatus += "|" + state.inactivityStatus[i];
      TransactionInprogressGetParams["InactivityStatus"] = inactivityStatus;
    }
    // EVES-5262: changes of function getTransactionInprogressParams
    appendSessionIdentifierFilter(TransactionInprogressGetParams, state.identifierFilter);
    return { ...TransactionInprogressGetParams };
  };

  const columns: columnsType[] = [
    {
      id: "actions",
      label: `${translate("general.actions")}`,
      minWidth: 90,
      textAlign: "center",
      maxWidth: 170,
      allowSort: false,
      projectField: "action",
    },
    {
      id: "id",
      label: `${translate("transactions.sessionId")}`,
      minWidth: 60,
      textAlign: "left",
      maxWidth: 150,
      allowSort: false,
      projectField: "id",
    },
    {
      id: "timestampDateFormated",
      label: `${translate("transactions.started_at")}`,
      minWidth: 60,
      textAlign: "left",
      maxWidth: 180,
      allowSort: true,
      sortKey: "timestamp",
      projectField: "timestamp",
    },
    {
      id: "chargeBox.chargeBoxId",
      label: `${translate("chargers.smart_charging.charging_plans.Charge_id")}`,
      minWidth: 60,
      textAlign: "left",
      maxWidth: 200,
      allowSort: true,
      sortKey: "chargeBox.chargeBoxId",
      projectField: "chargeBox.chargeBoxId",
      enableTooltip: false,
    },
    {
      id: "connectorId",
      label: `${translate("transactions.connector")}`,
      minWidth: 60,
      textAlign: "center",
      maxWidth: 150,
      allowSort: false,
      projectField: "connectorId",
      enableTooltip: false,
    },
    {
      id: "information",
      label: `${translate("chargers.connector_info_title")}`,
      minWidth: 60,
      textAlign: "left",
      maxWidth: 150,
      allowSort: false,
      projectField: "info",
    },
    {
      id: "currentTotalDuration",
      label: `${translate("transactions.duration")}`,
      minWidth: 60,
      textAlign: "left",
      maxWidth: 150,
      allowSort: false,
      projectField: "currentTotalDurationSecs",
    },
    {
      id: "currentTotalInactivitySecs",
      label: `${translate("transactions.inactivity")}`,
      minWidth: 60,
      textAlign: "left",
      maxWidth: 150,
      allowSort: false,
      projectField: "currentTotalInactivitySecs",
      enableTooltip: false,
    },
    getSessionIdentifierColumn(translate), // EVES-5262: changes of function getSessionIdentifierColumn
    {
      id: "getCurrentInstantWatts",
      label: `${translate("transactions.current_consumption")}`,
      minWidth: 60,
      textAlign: "center",
      maxWidth: 180,
      allowSort: false,
      projectField: "currentInstantWatts",
    },
    {
      id: "getCurrentTotalConsumptionWh",
      label: `${translate("transactions.total_consumption")}`,
      minWidth: 60,
      textAlign: "center",
      maxWidth: 150,
      allowSort: false,
      projectField: "currentTotalConsumptionWh",
    },
    {
      id: "getCurrentStateOfCharge",
      label: `${translate("transactions.state_of_charge")}`,
      minWidth: 60,
      textAlign: "center",
      maxWidth: 150,
      allowSort: false,
      projectField: "currentStateOfCharge",
    },
    {
      id: "getCurrentCumulatedPrice",
      label: `${translate("transactions.price")}`,
      minWidth: 60,
      textAlign: "left",
      maxWidth: 150,
      allowSort: false,
      projectField: "currentCumulatedPrice",
      visible: isPricingComponentActive,
    },
    {
      id: "companyName",
      label: `${translate("companies.title")}`,
      minWidth: 60,
      textAlign: "center",
      maxWidth: 150,
      allowSort: false,
      projectField: "company.name",
      visible: isOrganizationComponentActive,
    },
    {
      id: "siteName",
      label: `${translate("sites.title")}`,
      minWidth: 60,
      textAlign: "center",
      maxWidth: 150,
      allowSort: false,
      projectField: "site.name",
      visible: isOrganizationComponentActive,
    },
    {
      id: "siteAreaName",
      label: `${translate("site_areas.title")}`,
      minWidth: 60,
      textAlign: "center",
      maxWidth: 150,
      allowSort: false,
      projectField: "siteArea.name",
      visible: isOrganizationComponentActive,
    },
    {
      id: "userFullName",
      label: `${translate("transactions.user")}`,
      minWidth: 60,
      textAlign: "left",
      maxWidth: 190,
      allowSort: false,
      projectField: "user",
      visible: isUserCanListUsers,
    },
    {
      id: "tagID",
      label: `${translate("tags.id")}`,
      minWidth: 60,
      textAlign: "left",
      maxWidth: 150,
      allowSort: false,
      projectField: "tagID",
      visible: isUserCanListUsers,
    },
    {
      id: "tagVisualID",
      label: `${translate("tags.visual_id")}`,
      minWidth: 60,
      textAlign: "left",
      maxWidth: 150,
      allowSort: false,
      projectField: "tag.visualID",
      visible: isUserCanListUsers,
    },
    {
      id: "tagDescription",
      label: `${translate("general.description")}`,
      minWidth: 60,
      textAlign: "left",
      maxWidth: 150,
      allowSort: false,
      projectField: "tag.description",
      visible: isUserCanListUsers,
    },
    {
      id: "getCarCatalog",
      label: `${translate("car.title")}`,
      minWidth: 60,
      textAlign: "center",
      maxWidth: 150,
      allowSort: true,
      sortKey: "carCatalog",
      projectField: "carCatalog",
      visible: isCarComponentActive && isUserCanListCars,
    },
    {
      id: "carLicensePlate",
      label: `${translate("cars.license_plate")}`,
      minWidth: 60,
      textAlign: "center",
      maxWidth: 150,
      allowSort: true,
      sortKey: "car.licensePlate",
      projectField: "car.licensePlate",
      visible: isCarComponentActive && isUserCanUpdateCar,
    },
  ];

  const onClickStopTransaction = (record: any) => {
    disableLoaderForOnce();
    getChargingStationById(record.chargeBoxID, {
      WithSite: true,
      WithSiteArea: true,
    }).then((chargingStationRes: any) => {
      if (!chargingStationRes.canStopTransaction) {
        props.notificationService?.notify({
          message: "You are not authorized to stop this session",
          type: "error",
        });
        return;
      }
      props.dialogService?.showConfirm(
        {
          title: `${translate("general.stop")}`,
          description: `${translate(
            "chargers.stop_transaction_confirm"
          ).replace(/{{chargeBoxID}}/g, `'${record.chargeBoxID}'`)}`,
          confirmType: "YES_NO",
        },
        (result) => {
          if (result === "YES") {
            getChargingStationById(record.chargeBoxID, {
              WithSite: true,
              WithSiteArea: true,
            }).then((chargingStationRes: any) => {
              if (!chargingStationRes.canStopTransaction) {
                props.notificationService?.notify({
                  message: `${translate(
                    "chargers.action_error.transaction_stop_not_authorized"
                  )}`,
                  type: "error",
                });
                return;
              }
              store.dispatch(setLoader(true));
              stopSessionTransaction(record.id)
                .then((sessionStopRes: any) => {
                  if (sessionStopRes.status === "Accepted") {
                    props.notificationService?.notify({
                      message: `${translate(
                        "chargers.stop_transaction_success"
                      ).replace(
                        /{{chargeBoxID}}/g,
                        `'${record.chargeBoxID}'`
                      )}`,
                      type: "success",
                    });
                    fetchTransactionsInProgress();
                    fetchInProgressDashboard();
                  } else {
                    props.notificationService?.notify({
                      message: `${translate(
                        "chargers.stop_transaction_error"
                      )}`,
                      type: "error",
                    });
                  }
                })
                .finally(() => store.dispatch(setLoader(false)));
            });
          }
        }
      );
    });
  };

  const onTransactionDetailModalClose = () => {
    setStateData((currentData) => {
      return {
        ...currentData,
        isTransactionDetailModalOpen: false,
      };
    });
  };

  const primaryActions: ITableActionMenuModel[] = [
    {
      title: () => `${translate("general.stop")}`,
      icon: () => Stop,
      visible: (row: any) =>
        canRemoteStopTransactionAccess && row.canRemoteStopTransaction,
      iconColor: "error",
      onClick: onClickStopTransaction,
      "data-cy": "transactions-stop-action",
    },
  ];

  const secondaryActions: ITableActionMenuModel[] = [
    {
      title: () => `${translate("logs.redirect")}`,
      icon: () => OpenInNew,
      iconColor: "primary",
      onClick: (record: any) => {
        window.open(
          `#/logs?ChargingStationID=${record.chargeBoxID}&StartDateTime=${record.timestamp}&LogLevel=I`,
          "_blank"
        );
      },
      visible: () => canNavigateToLogs,
      "data-cy": "navigate-to-logs",
    },
    {
      title: () =>
        `${translate("chargers.smart_charging.charging_plans.redirect")}`,
      icon: () => OpenInNew,
      iconColor: "primary",
      onClick: (record: any) => {
        window.open(
          `#/charging-stations/charging-plans?ChargingStationID=${record.chargeBoxID}&TransactionID=${record.id}`,
          "_blank"
        );
      },
      visible: () => canNavigateToChargingPlans,
      "data-cy": "navigate-to-chargingplans",
    },
  ];

  const onTableChange = (params: any) => {
    setStateData((currentData) => {
      return {
        ...currentData,
        sortFields: params.sortFields,
      };
    });
  };

  const onPageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setStateData((currentData) => {
      return {
        ...currentData,
        page: newPage,
      };
    });
  };

  const onRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setStateData((currentData) => {
      return {
        ...currentData,
        page: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const onOwnerSelect = (selectedIssuerInfo: any) => {
    setStateData((currentData) => {
      return {
        ...currentData,
        isResetBtnDisabled:
          (selectedIssuerInfo.defaultIssuer ||
            selectedIssuerInfo.issuerName === Owner.CurrentOrgAPI) &&
          !state.search &&
          !state.chargingStationId &&
          !state.siteID &&
          !state.siteAreaID &&
          !state.userID &&
          !state.visualTagID &&
          (state.connectorID == -1 || !state.connectorID),
        issuerName: selectedIssuerInfo.issuerName,
        defaultIssuer: selectedIssuerInfo.defaultIssuer,
        issuer: selectedIssuerInfo.issuer ?? currentData.issuer,
      };
    });
  };

  const ConnectorCell = (row: any) => {
    return (
      <Tooltip
        title={row?.status}
        PopperProps={{ disablePortal: true }}
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: "common.white",
              color: "black",
              borderStyle: "solid",
              borderWidth: "1px",
              position: "fixed",
              top: -30,
              left: 20,
            },
          },
        }}
        followCursor={false}
        enterNextDelay={500}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Connector {...row} />
        </div>
      </Tooltip>
    );
  };

  const loadInProgressData = async () => {
    store.dispatch(setLoader(true));
    try {
      await Promise.all([
        fetchTransactionsInProgress(),
        fetchInProgressDashboard(),
      ]);
    } finally {
      store.dispatch(setLoader(false));
    }
  };

  useEffect(() => {
    loadInProgressData();
  }, [
    state.limit,
    state.page,
    state.sortFields,
    state.issuer,
    state.chargingStationId,
    state.visualTagID,
    state.userID,
    state.connectorID,
    state.siteAreaID,
    state.userID,
    state.search,
    state.connectorID,
    state.defaultIssuer,
    state.issuerName,
    state.subStationID,
    state.feederID,
    state.transformerID,
    state.inactivityStatus,
    state.identifierFilter,
    stateOfCharge,
    state.siteID, // EVES-1907
  ]);

  const resetChargingPlanFilter = () => {
    setStateData((currentData) => {
      return {
        ...currentData,
        chargingStationId: "",
        chargingStationName: "",
        chargingStationID: "",
        isChargingStationLookupModalOpen: false,
      };
    });
  };

  const onChargingStationSelect = (chargingStations: any) => {
    const chargingStationName =
      chargingStations?.length > 1
        ? `${chargingStations[0].id} (+${chargingStations.length - 1})`
        : chargingStations?.length && chargingStations[0].id;

    setStateData((currentData) => {
      return {
        ...currentData,
        isChargingStationLookupModalOpen: false,
        chargingStationId: chargingStations
          .map((chargingStation: any) => chargingStation.id)
          .join("|"),
        chargingStationName: chargingStationName,
        isResetBtnDisabled: false,
      };
    });
  };

  const setChargingStationFilter = () => {
    if (!isOnClickSiteFilterClear) {
      setStateData((currentData) => {
        return {
          ...currentData,
          isChargingStationLookupModalOpen: true,
        };
      });
    }
    isOnClickSiteFilterClear = false;
  };

  const onFilterApplied = (searchText: string) => {
    setStateData((currentData) => {
      return {
        ...currentData,
        search: searchText,
        isResetBtnDisabled:
          (state.defaultIssuer || state.issuerName === Owner.CurrentOrgAPI) &&
          !state.search &&
          !state.siteID &&
          !state.siteAreaID &&
          !state.userID &&
          !state.visualTagID &&
          searchText === "" &&
          (state.connectorID == -1 || !state.connectorID) &&
          state.inactivityStatus.length == 0 &&
          state.identifierFilter.length == 0,
      };
    });
  };

  const onClearSelectedChargingStation = () => {
    isOnClickSiteFilterClear = true;
    chargingStationLookupRef?.current?.setFocus();
    setStateData((currentData) => {
      return {
        ...currentData,
        chargingStationId: "",
        chargingStationName: "",
        isSiteLookupModalOpen: false,
        isResetBtnDisabled:
          (state.defaultIssuer || state.issuerName === Owner.CurrentOrgAPI) &&
          !state.search &&
          !state.siteID &&
          !state.siteAreaID &&
          !state.userID &&
          !state.visualTagID &&
          (state.connectorID == -1 || !state.connectorID) &&
          state.inactivityStatus.length == 0 &&
          state.identifierFilter.length == 0,
      };
    });
  };

  const setUserFilter = () => {
    setStateData((currentData) => {
      return {
        ...currentData,
        showUserLookUpModal: true,
      };
    });
  };

  const onClearSelectedUser = (event: any) => {
    event && event.stopPropagation();
    setStateData((currentData) => {
      return {
        ...currentData,
        userID: "",
        userName: "",
        isResetBtnDisabled:
          (state.defaultIssuer || state.issuerName === Owner.CurrentOrgAPI) &&
          !state.search &&
          !state.chargingStationId &&
          !state.siteID &&
          !state.siteAreaID &&
          !state.visualTagID &&
          (state.connectorID == -1 || !state.connectorID),
      };
    });
  };

  const onUserFilterModalClose = () => {
    setStateData((currentData) => {
      return {
        ...currentData,
        showUserLookUpModal: false,
      };
    });
  };

  const getFormatedRFIDCard = (tag: any) => {
    if (tag.length > 1) {
      return `${tag[0].visualID} (+ ${tag.length - 1})`;
    } else {
      return `${tag[0].visualID}`;
    }
  };

  const onUserSelected = (users: any) => {
    const userName =
      users?.length > 1
        ? `${users[0].firstName} ${users[0].name} (+${users?.length - 1})`
        : users?.length && `${users[0].firstName} ${users[0].name}`;
    setStateData((currentDate) => {
      return {
        ...currentDate,
        userID: users.map((user: any) => user.id).join("|"),
        userName: userName,
        showUserLookUpModal: false,
        isResetBtnDisabled: false,
      };
    });
  };

  const exportSession = () => {
    props.dialogService?.showConfirm(
      {
        title: `${translate("transactions.dialog.export.title")}`,
        description: `${translate("transactions.dialog.export.confirm")}`,
        confirmType: "YES_NO",
      },
      (result) => {
        if (result === "YES") {
          const { timeZone } = getClientTimezone();

          const historyParams: any = {
            Issuer: state.issuer,
            StartDateTime: state.startDate,
            EndDateTime: state.endDate,
            Statistics: TransactionStatisticsType.ONGOING,
            Status: "active",
            TimeZone: timeZone,
          };
          exportSessions(historyParams).then((res: any) => {
            const blob = new Blob([res]);
            saveAs(blob, "exported-session.csv");
          });
        }
      }
    );
  };

  const setRFIDFilter = () => {
    setStateData((currentData) => {
      return {
        ...currentData,
        showRFIDFilterModal: true,
      };
    });
  };

  const onRFIDFilterModalClose = () => {
    setStateData((currentData) => {
      return {
        ...currentData,
        showRFIDFilterModal: false,
      };
    });
  };

  const onClearSelectedRFID = (event: any) => {
    event && event.stopPropagation();
    setStateData((currentData) => {
      return {
        ...currentData,
        visualTagID: "",
        RFIDFilterValue: "",
        isResetBtnDisabled:
          (state.defaultIssuer || state.issuerName === Owner.CurrentOrgAPI) &&
          !state.search &&
          !state.chargingStationId &&
          !state.siteID &&
          !state.siteAreaID &&
          !state.userID &&
          (state.connectorID == -1 || !state.connectorID) &&
          state.inactivityStatus.length == 0 &&
          state.identifierFilter.length == 0,
      };
    });
  };

  const onRFIDCardSelected = (selectedTag: any) => {
    const sortedObj = Object.values(selectedTag).sort((a: any, b: any) =>
      a.id > b.id ? 1 : -1
    );
    const selectedItems = sortedObj
      ?.map((sessionTag: any) => sessionTag.visualID)
      .join("|");
    setStateData((currentData) => {
      return {
        ...currentData,
        visualTagID: selectedItems,
        RFIDFilterValue: getFormatedRFIDCard(sortedObj),
        showRFIDFilterModal: false,
        isResetBtnDisabled: false,
      };
    });
  };

  const setSiteFilter = () => {
    if (!isOnClickSiteFilterClear) {
      setStateData((currentData) => {
        return {
          ...currentData,
          isSiteLookupModalOpen: true,
        };
      });
    }
    isOnClickSiteFilterClear = false;
  };

  const onClearSelectedSite = () => {
    isOnClickSiteFilterClear = true;
    siteLookupRef?.current?.setFocus();
    setStateData((currentData) => {
      return {
        ...currentData,
        siteID: "",
        siteName: "",
        isSiteLookupModalOpen: false,
        isResetBtnDisabled:
          (state.defaultIssuer || state.issuerName === Owner.CurrentOrgAPI) &&
          !state.search &&
          !state.chargingStationId &&
          !state.siteAreaID &&
          !state.userID &&
          !state.visualTagID &&
          (state.connectorID == -1 || !state.connectorID) &&
          state.inactivityStatus.length == 0 &&
          state.identifierFilter.length == 0,
      };
    });
  };

  const resetSiteFilter = () => {
    setStateData((currentData) => {
      return {
        ...currentData,
        isSiteLookupModalOpen: false,
      };
    });
  };

  const onSiteSelect = (sites: any) => {
    const siteName =
      sites?.length > 1
        ? `${sites[0].name} (+${sites?.length - 1})`
        : sites?.length && sites[0].name;
    setStateData((currentData) => {
      return {
        ...currentData,
        isSiteLookupModalOpen: false,
        siteID: sites.map((site: any) => site.id).join("|"),
        siteName: siteName,
        isResetBtnDisabled: false,
      };
    });
  };

  const setSiteAreaFilter = () => {
    if (!isOnClickSiteAreaFilterClear) {
      setStateData((currentData) => {
        return {
          ...currentData,
          isSiteAreaLookupModalOpen: true,
        };
      });
    }
    isOnClickSiteAreaFilterClear = false;
  };

  const onClearSelectedSiteArea = () => {
    isOnClickSiteAreaFilterClear = true;
    siteAreaLookupRef?.current?.setFocus();
    setStateData((currentData) => {
      return {
        ...currentData,
        siteAreaID: "",
        siteAreaName: "",
        isSiteAreaLookupModalOpen: false,
        isResetBtnDisabled:
          (state.defaultIssuer || state.issuerName === Owner.CurrentOrgAPI) &&
          !state.search &&
          !state.chargingStationId &&
          !state.siteID &&
          !state.userID &&
          !state.visualTagID &&
          (state.connectorID == -1 || !state.connectorID),
      };
    });
  };

  const resetSiteAreaFilter = () => {
    setStateData((currentData) => {
      return {
        ...currentData,
        isSiteAreaLookupModalOpen: false,
      };
    });
  };

  const onSiteAreaSelect = (siteareas: any) => {
    const siteAreaName =
      siteareas?.length > 1
        ? `${siteareas[0].name} (+${siteareas?.length - 1})`
        : siteareas?.length && siteareas[0].name;
    setStateData((currentData) => {
      return {
        ...currentData,
        isSiteAreaLookupModalOpen: false,
        siteAreaID: siteareas.map((siteArea: any) => siteArea.id).join("|"),
        siteAreaName: siteAreaName,
        isResetBtnDisabled: false,
      };
    });
  };

  const onClickresetFilters = () => {
    searchBoxRef?.current?.resetSearch();
    chargingStationLookupRef?.current?.setFocus();
    onClearSelectedSite();
    onClearSelectedSiteArea();
    onClearSelectedUser(null);
    onClearSelectedRFID(null);
    setStateData((currentData) => {
      return {
        ...currentData,
        issuer: true,
        siteAreaID: "",
        chargingStationId: "",
        isOnClickSiteFilterClear: true,
        chargingStationName: "",
        connectorID: null,
        isResetBtnDisabled: true,
        defaultIssuer: true,
        // Cleared on reset for gridify filters kept in state even when lookup UI is unused here.
        subStationID: "",
        subStationName: "",
        feederID: "",
        feederName: "",
        transformerID: "",
        transformerName: "",
        identifierFilter: [],
        inactivityStatus: [],
      };
    });
  };

  // EVES-5262: changes of function onIdentifierSelect
  const onIdentifierSelect = (selectedItems: string[]) => {
    const updatedItems = mapSessionIdentifierFilterSelection(selectedItems);
    setStateData((currentData) => ({
      ...currentData,
      identifierFilter: updatedItems,
      isResetBtnDisabled:
        selectedItems.length > 0
          ? false
          : (state.defaultIssuer || state.issuerName === Owner.CurrentOrgAPI) &&
          !state.search &&
          !state.chargingStationId &&
          !state.siteID &&
          !state.siteAreaID &&
          !state.userID &&
          !state.visualTagID &&
          (state.connectorID == -1 || !state.connectorID) &&
          state.inactivityStatus.length === 0,
    }));
  };

  const StatusCell = (row: any) => {
    return (
      <CellStatus
        label={
          row.active
            ? `${translate("tags.activated")}`
            : `${translate("tags.deactivated")}`
        }
        type={row.active ? "Available" : "Faulted"}
      />
    );
  };

  const onConnectorSelect = (connectorID: string[]) => {
    const filter: number[] = [];
    connectorID.forEach((item: string) => {
      filter.push(parseInt(item[0]));
    });
    setStateData((currentData) => ({
      ...currentData,
      connectorID: filter.join("|"),
      isResetBtnDisabled:
        connectorID.length > 0
          ? false
          : (state.defaultIssuer || state.issuerName === Owner.CurrentOrgAPI) &&
          !state.search &&
          !state.chargingStationId &&
          !state.siteID &&
          !state.siteAreaID &&
          !state.userID &&
          !state.visualTagID &&
          state.identifierFilter.length == 0,
    }));
  };

  const handleStopMultiple = () => {
    state.selectedRecords.map((item) => {
      getChargingStationById(item.chargeBoxID, {
        WithSite: true,
        WithSiteArea: true,
      }).then((chargingStationRes: any) => {
        if (!chargingStationRes.canStopTransaction) {
          props.notificationService?.notify({
            message: `${translate(
              "chargers.action_error.transaction_stop_not_authorized"
            )}`,
            type: "error",
          });
          return;
        }
        stopSessionTransaction(item.id).then((sessionStopRes: any) => {
          if (sessionStopRes.status === "Accepted") {
            props.notificationService?.notify({
              message: `${translate(
                "chargers.stop_transaction_success"
              ).replace(/{{chargeBoxID}}/g, `'${item.chargeBoxID}'`)}`,
              type: "success",
            });
            fetchTransactionsInProgress();
            fetchInProgressDashboard();
          } else {
            props.notificationService?.notify({
              message: `${translate("chargers.stop_transaction_error")}`,
              type: "error",
            });
          }
        });
      });
    });
  };

  const alignStyle: CSSProperties = { alignItems: "flex-end !important" };
  const resetSubStationIdFilter = () => {
    setStateData((currentData) => {
      return { ...currentData, isSubStationIdLookupModalOpen: false };
    });
  };

  const onSubStationIdSelect = (substations: any) => {
    const subStationName =
      substations?.length > 1
        ? `${substations[0].name} (+${substations?.length - 1})`
        : substations?.length && substations[0].name;
    setStateData((currentData) => {
      return {
        ...currentData,
        isSubStationIdLookupModalOpen: false,
        subStationID: substations
          .map((subStation: any) => subStation.name)
          .join("|"),
        subStationName: subStationName,
        isResetBtnDisabled: false,
      };
    });
  };


  const resetFeederIdFilter = () => {
    setStateData((currentData) => {
      return { ...currentData, isFeederIdLookupModalOpen: false };
    });
  };

  const onFeederIdSelect = (feeders: any) => {
    const feederName =
      feeders?.length > 1
        ? `${feeders[0].name} (+${feeders?.length - 1})`
        : feeders?.length && feeders[0].name;
    setStateData((currentData) => {
      return {
        ...currentData,
        isFeederIdLookupModalOpen: false,
        feederID: feeders.map((feeder: any) => feeder.name).join("|"),
        feederName: feederName,
        isResetBtnDisabled: false,
      };
    });
  };


  const resetTransformerIdFilter = () => {
    setStateData((currentData) => {
      return { ...currentData, isTransformerIdLookupModalOpen: false };
    });
  };

  const onTransformerIdSelect = (transformer: any) => {
    const transformerName =
      transformer?.length > 1
        ? `${transformer[0].name} (+${transformer?.length - 1})`
        : transformer?.length && transformer[0].name;

    setStateData((currentData) => {
      return {
        ...currentData,
        isTransformerIdLookupModalOpen: false,
        transformerID: transformer.map((trans: any) => trans.name).join("|"),
        transformerName,
        isResetBtnDisabled: false,
      };
    });
  };

  const onSelectedRow = (data: any) => {
    setStateData((currentData) => {
      return {
        ...currentData,
        selectedRecords: data, // Used by ButtonGroup bulk stop via state.selectedRecords.
      };
    });
  };

  //Mapping Stats value for InProgess
  const stats = sessionStatsMapping(state.stats);

  const ChargeBoxId = (record) => {
    return record.chargeBox.chargeBoxId;
  };

  return (
    <>
      {state.showUserLookUpModal && (
        <LookupComponent
          title={`${translate("users.select_users")}`}
          showLookupModal={state.showUserLookUpModal}
          onModalClose={onUserFilterModalClose}
          selectionMode="multiple"
          entityType={LookupEntityType.SESSION_USER}
          params={[{ key: "Issuer", value: true }]}
          onSelect={onUserSelected}
          defaultSortColumn="name"
          data-cy="session-select-user-lookup"
        />
      )}
      {state.showRFIDFilterModal && (
        <LookupComponent
          data-cy="RFIDLookUpModal"
          title={`${translate("tags.select_tags")}`}
          showLookupModal={state.showRFIDFilterModal}
          onModalClose={onRFIDFilterModalClose}
          selectionMode="multiple"
          entityType={LookupEntityType.SESSION_RFID_TAG}
          tableChildren={<StatusCell slot="statusCustomValue" />}
          params={
            state.userID
              ? [
                { key: "Issuer", value: true },
                { key: "WithUser", value: true },
                { key: "UserID", value: state.userID },
              ]
              : [
                { key: "Issuer", value: true },
                { key: "WithUser", value: true },
              ]
          }
          onSelect={onRFIDCardSelected}
          defaultSortColumn="id"
        />
      )}

      <Content
        contentTop={
          <Grid>
            <Grid
              container
              item
              display={"flex"}
              justifyContent={"space-between"}
            >
              <Grid item xs={8} lg={9} md={8} sm={6} xl={9}>
                {showfilter && (
                  <Grid
                    container
                    item
                    spacing={2}
                    rowSpacing={1}
                    sx={alignStyle}
                  >
                    <Grid
                      data-cy="owner-dropdown-filter"
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={2.4}
                      xl={2.4}
                    >
                      <OwnerFilter
                        defaultIssuer={state.defaultIssuer}
                        onChange={onOwnerSelect}
                      />
                    </Grid>
                    {isOrganizationComponentActive && (
                      <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4}>
                        <EvesTextbox
                          value={state.siteName}
                          id="inProgress-standard-search"
                          label={`${translate("general.search_site")}`}
                          data-cy="select-site"
                          type="text"
                          variant="standard"
                          onClick={setSiteFilter}
                          onChange={onFilterApplied}
                          ref={siteLookupRef}
                          isFilter={true}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <EvesIconButton
                                  icon={Close}
                                  fontSize={15}
                                  onClick={onClearSelectedSite}
                                ></EvesIconButton>
                              </InputAdornment>
                            ),
                            readOnly: true,
                          }}
                        />
                      </Grid>
                    )}
                    {isOrganizationComponentActive && (
                      <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4}>
                        <EvesTextbox
                          value={state.siteAreaName}
                          id="inProgress-standard-search"
                          label={`${translate("site_areas.titles")}`}
                          data-cy="select-site-area"
                          type="text"
                          variant="standard"
                          onClick={setSiteAreaFilter}
                          onChange={onFilterApplied}
                          isFilter={true}
                          ref={siteAreaLookupRef}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <EvesIconButton
                                  icon={Close}
                                  fontSize={15}
                                  onClick={onClearSelectedSiteArea}
                                ></EvesIconButton>
                              </InputAdornment>
                            ),
                            readOnly: true,
                          }}
                        />
                      </Grid>
                    )}
                    {isUserCanListChargingStations && (
                      <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4}>
                        <EvesTextbox
                          value={state.chargingStationName}
                          style={{
                            width: "100%",
                            cursor: "pointer",
                          }}
                          id="sessions-charging-station-lookup"
                          label={`${translate("OCPP ID")}`}
                          type="text"
                          variant="standard"
                          data-cy="sessions-charging-station-lookup"
                          onClick={setChargingStationFilter}
                          onChange={onFilterApplied}
                          ref={chargingStationLookupRef}
                          isFilter={true}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <EvesIconButton
                                  icon={Close}
                                  fontSize={15}
                                  onClick={onClearSelectedChargingStation}
                                ></EvesIconButton>
                              </InputAdornment>
                            ),
                            readOnly: true,
                          }}
                        />
                      </Grid>
                    )}
                    {isUserCanListChargingStations && (
                      <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4}>
                        <FilterSelector
                          filterOption={Filters.CONNECTORS}
                          defaultIssuer={state.defaultIssuer}
                          onChange={onConnectorSelect}
                          isResetBtnDisabled={state.isResetBtnDisabled}
                          data-cy="connector-filter"
                        />
                      </Grid>
                    )}
                    {isUserCanListUsers && (
                      <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4}>
                        <EvesTextbox
                          value={state.userName}
                          id="User-standard-search"
                          label={`${translate("sites.users")}`}
                          data-cy="User-filter"
                          type="text"
                          variant="standard"
                          onClick={setUserFilter}
                          onChange={onFilterApplied}
                          isFilter={true}
                          ref={UserLookupRef}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <EvesIconButton
                                  icon={Close}
                                  fontSize={15}
                                  onClick={onClearSelectedUser}
                                ></EvesIconButton>
                              </InputAdornment>
                            ),
                            readOnly: true,
                          }}
                        />
                      </Grid>
                    )}
                    {isUserCanListTags && (
                      <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4}>
                        <EvesTextbox
                          value={state.RFIDFilterValue}
                          id="RFID-standard-search"
                          label={`${translate("users.tags")}`}
                          data-cy="RFID-filter"
                          type="text"
                          variant="standard"
                          onClick={setRFIDFilter}
                          onChange={onFilterApplied}
                          isFilter={true}
                          ref={RFIDLookupRef}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <EvesIconButton
                                  icon={Close}
                                  fontSize={15}
                                  onClick={onClearSelectedRFID}
                                ></EvesIconButton>
                              </InputAdornment>
                            ),
                            readOnly: true,
                          }}
                        />
                      </Grid>
                    )}
                    <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4}>
                      <FilterSelector
                        filterOption={Filters.SESSION_IDENTIFIER}
                        defaultIssuer={state.defaultIssuer}
                        onChange={onIdentifierSelect}
                        isResetBtnDisabled={state.isResetBtnDisabled}
                        data-cy="session-identifier-filter"
                      />
                    </Grid>
                    <Grid
                      data-cy="search-field"
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={2.4}
                      xl={2.4}
                    >
                      <SearchBox
                        ref={searchBoxRef}
                        onChange={onFilterApplied}
                        onRemoveClick={fetchTransactionsInProgress}
                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>
              <Grid item mt={1} xs={4} sm={6} lg={3} xl={3} md={4}>
                <ButtonGroup
                  {...{
                    showfilter,
                    setShowfilter,
                    resetFilters: onClickresetFilters,
                    state,
                    // isExport: true, // Export hidden; handler kept for future use.
                    multiple: true, // Run multiple auto-refresh callbacks together.
                    isSession: true, // Bulk action shows Stop icon/tooltip instead of delete/trash.
                    autoRefreshStatus: true, // Auto-refresh enabled by default on this page.
                    intervalsAndFunctions: [
                      {
                        interval: autoRefresh.sessions.IN_PROGRESS,
                        func: fetchTransactionsInProgress, // Refresh in-progress session table.
                      },
                      {
                        interval: autoRefresh.sessions.IN_PROGRESS,
                        func: fetchInProgressDashboard, // Refresh Active Sessions / Consumption cards.
                      },
                    ],
                    isDelete: true, // Show bulk action when rows are selected.
                    onClickDelete: handleStopMultiple, // Stop all selected in-progress sessions.
                    onClickExport: exportSession,
                  }}
                />
              </Grid>
            </Grid>
            {/* 
              Task: EVES-4144
              Author: Abhishek Bharti
              Description: Hide Active Sessions and Consumptions cards when accessed via email link with transactionID param 
            */}
            {canViewSessionProgressSummary && !transactionIDParam && (
              <Grid container item spacing={"12px"} xs={12} my={"12px"}>
                <Grid item xs={3}>
                  <CommonCard
                    img={session}
                    headerText="Active Sessions"
                    footerText={stats?.session}
                  />
                </Grid>
                <Grid item xs={3}>
                  <CommonCard
                    img={consumption}
                    headerText="Consumptions"
                    footerText={stats?.consumption}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        }
        contentBody={
          <DataTable
            className="tranasction-in-progress-table"
            //EVES-1982 Feature Environment Gridify module-Session In progress defects
            //Developer: Abhishek Bharti
            //Date: 24/10/2024
            ref={dataTableRef}
            rows={state.rows}
            columns={columns}
            totalRowsCount={state.totalRowsCount}
            actionsMenu={primaryActions}
            contextActionsMenu={secondaryActions}
            defaultSortField={defaultSortColumn}
            defaultSortDescending={true}
            projectFields={state.projectFields}
            selectionMode={canRemoteStopTransactionAccess && "multiple"}
            // EVES-1789 added user role to action button
            onRowSelectionChange={onSelectedRow}
            data-cy="transactions-inprogress-table"
            componentName="Session"
            onChange={onTableChange}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
            count={state.totalRowsCount}
            limit={state.limit}
            page={state.page}
            tablePagination={true}
            selectedRows={state.selectedRecords}
          >
            <ConnectorCell slot="connectorId" />
            <InActivityCell slot="currentTotalInactivitySecs" />
            <SessionIdentifierCell slot="identifier" />
            <ChargeBoxId slot="chargeBox.chargeBoxId" />
          </DataTable>
        }
      ></Content>

      {state.isChargingStationLookupModalOpen && (
        <LookupComponent
          data-cy="sessions-charging-plan-lookup"
          title={`${translate("chargers.select_id")}`}
          showLookupModal={state.isChargingStationLookupModalOpen}
          onModalClose={resetChargingPlanFilter}
          selectionMode="multiple"
          entityType={LookupEntityType.CHARGINGSTATION}
          params={
            state.siteAreaID
              ? [
                { key: "Issuer", value: state.issuer },
                { key: "SiteAreaID", value: state.siteAreaID },
              ]
              : [{ key: "Issuer", value: state.issuer }]
          }
          onSelect={onChargingStationSelect}
          defaultSortColumn="id"
        />
      )}

      {state.isSiteLookupModalOpen && (
        <LookupComponent
          title={`${translate("sites.select_sites")}`}
          showLookupModal={state.isSiteLookupModalOpen}
          onModalClose={resetSiteFilter}
          selectionMode="multiple"
          entityType={LookupEntityType.SITE}
          params={[{ key: "Issuer", value: state.issuer }]}
          onSelect={onSiteSelect}
          defaultSortColumn="name"
          data-cy="site-filter" // EVES-1907
        />
      )}
      {state.isSiteAreaLookupModalOpen && (
        <LookupComponent
          title={`${translate("site_areas.select_site_areas")}`}
          showLookupModal={state.isSiteAreaLookupModalOpen}
          onModalClose={resetSiteAreaFilter}
          selectionMode="multiple"
          entityType={LookupEntityType.SITEAREA}
          params={[
            { key: "Issuer", value: state.issuer },
            { key: "SiteID", value: state.siteID || null },
            { key: "WithSite", value: true },
          ]}
          onSelect={onSiteAreaSelect}
          defaultSortColumn="name"
        />
      )}
      {state.isTransactionDetailModalOpen && (
        <TransactionDetails
          transactionId={state.selectedTransactionId}
          chargingStationId={state.selectedChargingStationID}
          connectorId={state.selectedConnectorID}
          onClose={onTransactionDetailModalClose}
          popopOpen={state.isTransactionDetailModalOpen}
        />
      )}

      {state.isSubStationIdLookupModalOpen && (
        <LookupComponent
          title={`${translate("site_areas.select_substation_id")}`}
          showLookupModal={state.isSubStationIdLookupModalOpen}
          onModalClose={resetSubStationIdFilter}
          selectionMode="multiple"
          entityType={LookupEntityType.SUBSTATIONID}
          params={[
            { key: "Issuer", value: state.issuer },
            { key: "SubStationID", value: state.subStationID || null },
            { key: "WithSite", value: true },
          ]}
          onSelect={onSubStationIdSelect}
          defaultSortColumn="name"
        />
      )}
      {state.isFeederIdLookupModalOpen && (
        <LookupComponent
          title={`${translate("site_areas.select_feeder_id")}`}
          showLookupModal={state.isFeederIdLookupModalOpen}
          onModalClose={resetFeederIdFilter}
          selectionMode="multiple"
          entityType={LookupEntityType.FEEDERID}
          params={[
            { key: "Issuer", value: state.issuer },
            { key: "FeederID", value: state.feederID || null },
            { key: "WithSite", value: true },
            { key: "SubStationID", value: state.subStationID || null },
          ]}
          onSelect={onFeederIdSelect}
          defaultSortColumn="name"
        />
      )}
      {state.isTransformerIdLookupModalOpen && (
        <LookupComponent
          title={`${translate("site_areas.select_transformer_id")}`}
          showLookupModal={state.isTransformerIdLookupModalOpen}
          onModalClose={resetTransformerIdFilter}
          selectionMode="multiple"
          entityType={LookupEntityType.TRANSFORMERID}
          params={[
            { key: "Issuer", value: state.issuer },
            { key: "TransformerID", value: state.transformerID || null },
            { key: "WithSite", value: true },
            { key: "FeederID", value: state.feederID || null },
            { key: "SubStationID", value: state.subStationID || null },
            { key: "FeederID", value: state.feederID || null },
          ]}
          onSelect={onTransformerIdSelect}
          defaultSortColumn="name"
        />
      )}
    </>
  );
};

export default withContext(TransactionsInProgress);
